import { render, staticRenderFns } from "./add-material-modal.vue?vue&type=template&id=fc9622a8&scoped=true"
import script from "./add-material-modal.vue?vue&type=script&lang=js"
export * from "./add-material-modal.vue?vue&type=script&lang=js"
import style0 from "./add-material-modal.vue?vue&type=style&index=0&id=fc9622a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9622a8",
  null
  
)

export default component.exports